import React from 'react';
import { Button, Typography, Box, Container, Grid, Stack } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { IMAGES, PHONE_DISPLAY, PHONE_HREF, yellowGlowSx } from '../theme';
import { useQuote } from './QuoteDialog';
export function Hero() {
  const {
    openQuote
  } = useQuote();
  return <Box id="hero" sx={{
    position: 'relative',
    minHeight: {
      xs: '88vh',
      md: '90vh'
    },
    display: 'flex',
    alignItems: 'center',
    py: {
      xs: 8,
      md: 0
    },
    backgroundImage: {
      // Mobile: text spans the full width, so keep a stronger floor across
      // the whole image while still letting the right edge breathe.
      xs: `linear-gradient(to right, rgba(4, 78, 92, 0.96) 0%, rgba(4, 78, 92, 0.82) 50%, rgba(4, 78, 92, 0.5) 100%), url(${IMAGES.hero})`,
      // Desktop: a left-heavy green gradient that fades to fully transparent
      // past the text column, revealing the patio on the right.
      md: `linear-gradient(to right, rgba(4, 78, 92, 0.95) 0%, rgba(4, 78, 92, 0.88) 28%, rgba(4, 78, 92, 0.45) 55%, rgba(4, 78, 92, 0) 75%), url(${IMAGES.hero})`
    },
    backgroundSize: 'cover',
    backgroundPosition: 'right center',
    color: 'white'
  }} data-id="element-61">
      <Container maxWidth="lg" data-id="element-62">
        <Grid container data-id="element-63">
          <Grid item xs={12} md={8} lg={7} data-id="element-64">
            <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mb: {
              xs: 2.5,
              md: 3
            }
          }} data-id="element-65">
              <Box sx={{
              display: 'inline-flex',
              alignItems: 'center',
              bgcolor: 'secondary.main',
              color: 'secondary.contrastText',
              px: {
                xs: 1.25,
                md: 1.75
              },
              py: {
                xs: 0.5,
                md: 0.75
              },
              borderRadius: 2,
              boxShadow: '0 4px 14px rgba(0,0,0,0.25)'
            }} data-id="element-66">
                <FavoriteIcon sx={{
                mr: 0.75,
                fontSize: {
                  xs: 15,
                  md: 18
                }
              }} data-id="element-67" />
                <Typography fontWeight={800} sx={{
                fontSize: {
                  xs: '0.7rem',
                  md: '0.85rem'
                },
                letterSpacing: {
                  xs: 0.5,
                  md: 1
                },
                textTransform: 'uppercase',
                lineHeight: 1.3
              }} data-id="element-68">
                  Proudly Woman-Owned
                </Typography>
              </Box>

              <Box sx={{
              display: 'inline-flex',
              alignItems: 'center',
              bgcolor: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.4)',
              px: {
                xs: 1.25,
                md: 1.75
              },
              py: {
                xs: 0.5,
                md: 0.75
              },
              borderRadius: 2
            }} data-id="element-69">
                <LocalFireDepartmentIcon sx={{
                mr: 0.75,
                color: 'secondary.main',
                fontSize: {
                  xs: 15,
                  md: 18
                }
              }} data-id="element-70" />
                <Typography fontWeight={700} sx={{
                fontSize: {
                  xs: '0.7rem',
                  md: '0.85rem'
                },
                letterSpacing: {
                  xs: 0.5,
                  md: 1
                },
                textTransform: 'uppercase',
                lineHeight: 1.3,
                color: 'white'
              }} data-id="element-71">
                  Supporting First Responders & Veterans 🚒 👮
                </Typography>
              </Box>

              <Box sx={{
              display: 'inline-flex',
              alignItems: 'center',
              bgcolor: 'rgba(255, 222, 89, 0.18)',
              px: {
                xs: 1.25,
                md: 1.75
              },
              py: {
                xs: 0.5,
                md: 0.75
              },
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'secondary.main'
            }} data-id="element-72">
                <LocationOnIcon color="secondary" sx={{
                mr: 0.75,
                fontSize: {
                  xs: 15,
                  md: 18
                }
              }} data-id="element-73" />
                <Typography color="secondary.main" fontWeight="bold" sx={{
                fontSize: {
                  xs: '0.7rem',
                  md: '0.85rem'
                },
                letterSpacing: {
                  xs: 0.5,
                  md: 1
                },
                textTransform: 'uppercase',
                lineHeight: 1.3,
                ...yellowGlowSx
              }} data-id="element-74">
                  Serving Brentwood, CA & Surrounding Areas
                </Typography>
              </Box>
            </Box>
            <Typography variant="h1" sx={{
            fontSize: {
              xs: '3.25rem',
              sm: '4.25rem',
              md: '5.5rem'
            },
            mb: {
              xs: 2,
              md: 3
            },
            lineHeight: 1.2
          }} data-id="element-75">
              Transform Your{' '}
              <Box component="span" sx={{
              color: 'secondary.main'
            }} data-id="element-76">
                Outdoor Living
              </Box>{' '}
              Space
            </Typography>
            <Typography sx={{
            mb: {
              xs: 4,
              md: 5
            },
            fontWeight: 400,
            opacity: 0.85,
            lineHeight: 1.6,
            maxWidth: '600px',
            fontSize: {
              xs: '0.95rem',
              md: '1.5rem'
            }
          }} data-id="element-77">
              A proudly woman-owned company crafting custom patio covers and
              pergolas that enhance your home's beauty and provide year-round
              comfort.
            </Typography>
            <Stack direction={{
            xs: 'column',
            sm: 'row'
          }} spacing={1.5} data-id="element-78">
              <Button variant="contained" color="secondary" size="large" onClick={openQuote} fullWidth sx={{
              fontSize: {
                xs: '1rem',
                md: '1.1rem'
              },
              py: 1.5,
              px: 4,
              width: {
                xs: '100%',
                sm: 'auto'
              }
            }} data-id="element-79">
                Get Your Free Estimate
              </Button>
              <Button variant="outlined" size="large" href={PHONE_HREF} fullWidth sx={{
              color: 'white',
              borderColor: 'rgba(255,255,255,0.6)',
              '&:hover': {
                borderColor: 'secondary.main',
                bgcolor: 'rgba(255,255,255,0.1)'
              },
              fontSize: {
                xs: '1rem',
                md: '1.1rem'
              },
              py: 1.5,
              px: 4,
              width: {
                xs: '100%',
                sm: 'auto'
              }
            }} data-id="element-80">
                Call {PHONE_DISPLAY}
              </Button>
            </Stack>

            <Stack direction={{
            xs: 'column',
            sm: 'row'
          }} spacing={{
            xs: 1.25,
            sm: 3
          }} sx={{
            mt: {
              xs: 4,
              md: 6
            }
          }} data-id="element-81">
              {['Licensed & Insured', 'Custom Designs', 'Expert Installation'].map(text => <Stack key={text} direction="row" spacing={1} alignItems="center" data-id="element-82">
                  <CheckCircleOutlineIcon color="secondary" sx={{
                fontSize: {
                  xs: 18,
                  md: 24
                }
              }} data-id="element-83" />
                  <Typography fontWeight="500" sx={{
                fontSize: {
                  xs: '0.875rem',
                  md: '1rem'
                }
              }} data-id="element-84">
                    {text}
                  </Typography>
                </Stack>)}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>;
}